// corporateEvents.js

const corporateEvents = {
  id: 10,
  title: "Corporate Events",
  questions: [
    {
      question: "Do you organize corporate events?",
      answer:
        "Yes, we manage conferences, seminars, launches, annual meets, and team-building events.",
    },
    {
      question: "Can branding be customized for events?",
      answer:
        "Yes, event branding, stage design, and marketing materials can be fully customized.",
    },
    {
      question: "Do you handle guest registrations?",
      answer:
        "Yes, we manage registrations, attendee coordination, and hospitality services.",
    },
  ],
};

export default corporateEvents;